// extracted by mini-css-extract-plugin
module.exports = {"react-renderer":"TableBlock_react-renderer__13o7s"};